import { DATA_STRIP_CONTENT_FIELDS } from './richTextLinksFields'

const DATA_STRIP_SECTION_FIELDS = `
  id
  sys { id publishedAt }
  content { ${DATA_STRIP_CONTENT_FIELDS} }
`

export const DATA_STRIP_GQL_FIELDS = `
  title
  sys { id publishedAt }
  intro { ${DATA_STRIP_SECTION_FIELDS} }
  middle { ${DATA_STRIP_SECTION_FIELDS} }
  next { ${DATA_STRIP_SECTION_FIELDS} }
  ending { ${DATA_STRIP_SECTION_FIELDS} }
  source {
    title
    sys { id publishedAt }
    content { ${DATA_STRIP_CONTENT_FIELDS} }
  }
`

const FAQ_ANSWER_FIELDS = `
  answer {
    json
    links {
      assets { block { sys { id } } }
      entries { block { sys { id } } }
      resources { block { sys { urn } } }
    }
  }
`

export const FAQ_COLLECTION_GQL_FIELDS = `
  faqCollection(limit: 50) {
    items {
      question
      ${FAQ_ANSWER_FIELDS}
      isFaqEnabled
      order
      sys { id publishedAt }
    }
  }
`

export const GEO_SUPPLEMENT_GQL_FIELDS = FAQ_COLLECTION_GQL_FIELDS

export const ARTICLE_BLOG_SUPPLEMENT_GQL_FIELDS = `
  keyTakeaways
  faqTitle
  dataStripVariablesJson {
    data
    month
    sys { id publishedAt }
  }
  dataStrip { ${DATA_STRIP_GQL_FIELDS} }
  ${FAQ_COLLECTION_GQL_FIELDS}
`

const TYPENAME_TO_ENTRY_QUERY = {
  WwwArticlePages: 'wwwArticlePages',
  WwwBlogPosts: 'wwwBlogPosts',
  WwwDebtConsolidationStatesCities: 'wwwDebtConsolidationStatesCities',
}

export function buildPageModelSupplementQuery(typename) {
  const entryQuery = TYPENAME_TO_ENTRY_QUERY[typename]
  if (!entryQuery) {
    return null
  }

  const fields =
    typename === 'WwwDebtConsolidationStatesCities'
      ? GEO_SUPPLEMENT_GQL_FIELDS
      : ARTICLE_BLOG_SUPPLEMENT_GQL_FIELDS

  return `
    query PageModelSupplement($preview: Boolean, $id: String!) {
      model: ${entryQuery}(id: $id, preview: $preview) {
        ${fields}
      }
    }
  `
}

export const PAGE_MODELS_WITH_SUPPLEMENT = Object.keys(TYPENAME_TO_ENTRY_QUERY)
